import posthog from 'posthog-js';

const apiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const apiHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
const hasPostHogCookie = document.cookie.split(';').some(
  (cookie) => cookie.trim().startsWith('ph_') && cookie.includes('_posthog=')
);
const persistence: 'localStorage+cookie' | 'memory' = hasPostHogCookie ? 'localStorage+cookie' : 'memory';

if (apiKey && apiHost) {
  posthog.init(apiKey, {
    api_host: apiHost,
    persistence: persistence,
    autocapture: false,
    disable_session_recording: true,
    disable_surveys: true,
  });
}

export default posthog;